import { createApp } from 'vue';
import PngToIcoConverter from '../Components/PngToIcoConverter.vue';

const root = document.getElementById('png-to-ico-converter');
if (root) {
  createApp(PngToIcoConverter).mount('#png-to-ico-converter');
}
